import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Modal */
import Modal from "react-modal"

/* Components */
import { InnerLayout } from "../../components"

/* Toast */
import { pushToast } from "../../components/Toast"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { utils } from "../../helpers"

/* REST API */
import { watchList, watchAdd, watchRemove, filters } from "../../api/Player"

/* Icons */
import { CloseIcon, BellIcon, OperatorIcon, PlayerIcon } from "./PlayerIcons"

/* Utils */
import { formatDate } from "./PlayerUtils"


/* Widget Watch — СПИСОК КОНТРОЛЯ ВХОДА: пара «игрок + оператор» и уведомление в телеграм */
class Watch extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            status: "loading",
            list: [],
            operators: [],
            player: "",
            operatorID: 0,
            waiting: false,
        }
    }

    /* Open Action */
    open = () => {
        this.setState({ visible: true, status: "loading", player: "", operatorID: 0 }, () => this.load())
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false })
    }

    /* Load Action — список контроля и операторы для выбора */
    load = () => {

        Promise.all([watchList(), filters()]).then(([watches, dictionary]) => {

            /* Check Answer */
            if (watches.status !== 200) {
                this.setState({ status: watches.status === 403 ? "permission" : "error", list: [] })
                return
            }

            /* Fields */
            const operators = (dictionary.status === 200 && Array.isArray(dictionary.data.operators)) ? dictionary.data.operators : []

            this.setState({ status: "ok", list: watches.data, operators })

        }).catch(() => {
            this.setState({ status: "network", list: [] })
        })
    }

    /* Add Action */
    add = () => {

        /* Fields */
        const { player, operatorID, waiting } = this.state

        /* Check Waiting */
        if (waiting) {
            return
        }

        /* Check Player */
        if (String(player).trim() === "") {
            pushToast({ text: t("plr.watchEnterPlayer"), type: "warning" })
            return
        }

        /* Check Operator */
        if (!parseInt(operatorID)) {
            pushToast({ text: t("plr.watchSelectOperator"), type: "warning" })
            return
        }

        /* Start Waiting */
        this.setState({ waiting: true })

        /* Send to REST API */
        watchAdd({ player: String(player).trim(), operatorID }).then((response) => {

            /* Already Exists */
            if (response.status === 201) {
                pushToast({ text: t("plr.watchExists"), type: "warning" })
                this.setState({ waiting: false })
                return
            }

            /* Saved */
            if (response.status === 200) {
                pushToast({ text: t("plr.watchAdded"), type: "success" })
                this.setState({ waiting: false, player: "" }, () => this.load())
                return
            }

            /* Anything Else */
            pushToast({ text: t("widget.somethingWrong"), type: "error" })
            this.setState({ waiting: false })

        }).catch(() => {
            pushToast({ text: t("widget.somethingWrong"), type: "error" })
            this.setState({ waiting: false })
        })
    }

    /* Remove Action */
    remove = (id) => {

        /* Send to REST API */
        watchRemove({ id }).then((response) => {

            /* Removed */
            if (response.status === 200) {
                pushToast({ text: t("plr.watchRemoved"), type: "success" })
                this.load()
                return
            }

            /* Anything Else */
            pushToast({ text: t("widget.somethingWrong"), type: "error" })

        }).catch(() => {
            pushToast({ text: t("widget.somethingWrong"), type: "error" })
        })
    }

    /* Draw The Form Of A New Watch */
    _form = () => {

        /* Fields */
        const { operators, player, operatorID, waiting } = this.state

        return (
            <div className="plr--watch-form">

                <div className="plr--watch-field">
                    <label>{t("plr.watchPlayer")}</label>
                    <input
                        value={player}
                        onChange={(event) => this.setState({ player: event.target.value })}
                        placeholder="AZ1123"
                    />
                </div>

                <div className="plr--watch-field">
                    <label>{t("plr.watchOperator")}</label>
                    <select value={operatorID} onChange={(event) => this.setState({ operatorID: event.target.value })}>
                        <option value={0}>{t("plr.watchSelectOperator")}</option>
                        {operators.map((item) => <option key={`${item.id}`} value={item.id}>{item.name}</option>)}
                    </select>
                </div>

                <div onClick={() => this.add()} className={`plr--watch-add ${waiting ? "waiting" : ""}`}>{t("plr.watchAdd")}</div>

            </div>
        )
    }

    /* Draw The List */
    _list = () => {

        /* Fields */
        const { list } = this.state

        /* Check List */
        if (list.length === 0) {
            return <div className="plr--watch-empty">{t("plr.watchEmpty")}</div>
        }

        return (
            <div className="plr--watch-list">
                {list.map((item) =>
                    <div className="plr--watch-row" key={`${item.id}`}>

                        <div className="plr--watch-cell name">
                            <PlayerIcon size={12} />
                            <span>{utils.checkValue(item.player, "—")}</span>
                            {item.firstName ? <b>{item.firstName}</b> : null}
                        </div>

                        <div className="plr--watch-cell">
                            <OperatorIcon size={12} />
                            <span>{utils.checkValue(item.operator, "—")}</span>
                        </div>

                        <div className="plr--watch-cell date">
                            {item.lastLogin ? `${t("plr.watchLastLogin")} ${formatDate(item.lastLogin)}` : t("plr.watchNeverEntered")}
                        </div>

                        <div onClick={() => this.remove(item.id)} className="plr--watch-remove">
                            <CloseIcon size={12} />
                        </div>

                    </div>
                )}
            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, status } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="plr--modal watch"
                overlayClassName="plr--overlay"
                closeTimeoutMS={200}
            >

                <div className="plr--modal-header">

                    <div className="plr--modal-icon">
                        <BellIcon size={16} />
                    </div>

                    <div className="plr--modal-head-text">
                        <h2>{t("plr.watchTitle")}</h2>
                        <p>{t("plr.watchSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="plr--modal-close">
                        <CloseIcon size={16} />
                    </div>

                </div>

                <div className="plr--modal-body">
                    {status !== "ok"
                        ? <InnerLayout status={status} reload={() => this.load()} />
                        : <>{this._form()}{this._list()}</>
                    }
                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    admin: state.admin,
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(Watch)
